import React from "react";
import { Tab } from "../components/Tab";
import { ImportDocumentsFromFile } from "./ImportDocumentsFromFile";
import { ImportDocumentsFromPim } from "./ImportDocumentsFromPim";

type Props = {
  token?: string;
  customerSlug?: string;
  apiToken?: string;
};

export const ImportDocuments: React.FC<Props> = ({
  token,
  customerSlug,
  apiToken,
}) => {
  const panes = [
    {
      menuItem: {
        key: "file",
        icon: <i className="material-icons">upload_file</i>,
        heading: "Import from File",
      },
      content: (
        <ImportDocumentsFromFile token={token} customerSlug={customerSlug} />
      ),
    },
    {
      menuItem: {
        key: "pim",
        icon: <i className="material-icons">cloud_download</i>,
        heading: "Import from PIM",
      },
      content: (
        <ImportDocumentsFromPim token={apiToken} customerSlug={customerSlug} />
      ),
    },
  ];

  return <Tab panes={panes} />;
};
